/** Pipe-set scoped WPS PDF import API paths (python-api). */

export function wpsImportBase(projectId: string, pipeSetId: string): string {
  return `/api/projects/${encodeURIComponent(projectId)}/pipe-sets/${encodeURIComponent(pipeSetId)}/wps-import`
}

export const wpsImportAdminBase = '/api/wps-import/admin'
